import { useProductBOMAPI } from "../../../api/productBom/useProductBOMAPI";
import { productBOMActions } from "./ProductBOMReducer";


export const useProductBOM = () => {
    const api = useProductBOMAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.productBOM.get(params);
              dispatch(productBOMActions.funGetProductBOM(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.productBOM.post(data);
        },
        put: async (data) => {
          return await api.productBOM.put(data);
        },
        delete: async (params) => {
          return await api.productBOM.delete(params);
        }
    };
    return { request };
  };